<template>

    <v-card
            v-if="projectInfo == null || projectInfo.lastModifiedDate == null "
            outlined
            class="mx-auto"
            style="width: 400px; height: 300px; justify-content: center"
            align="center"
    >
        <v-skeleton-loader
                ref="skeleton"
                type="card"
                class="mx-auto"
        >
        </v-skeleton-loader>
    </v-card>


    <v-card
            v-else
            outlined
            class="mx-auto"
            max-width="400"
            max-height="400"
    >

        <v-img
                :src="projectInfomation.img"
                max-width="400"
                max-height="300"
        >

            <slot name="chips">
                <v-row justify="end" style="margin-right: 1px">
                    <v-chip
                            v-if="checkNewChip"
                            class="ma-2"
                            color="red"
                            text-color="white"
                            style="margin-right: 10px"
                    >
                        NEW
                    </v-chip>
                    <v-chip
                            class="ma-2"
                            :color="displayChip.color"
                            text-color="white"
                    >
                        {{displayChip.display}}
                    </v-chip>
                    <v-chip
                            v-if="projectInfomation.shared && projectInfo.location == 'mine'"
                            class="ma-2"
                            color="orange"
                            text-color="white"
                    >
                        shared
                    </v-chip>
                </v-row>
            </slot>

        </v-img>

        <v-list-item three-line>
            <v-list-item-content>
                <v-list-item-title class="headline mb-1">
                    {{ projectInfomation.projectName }}
                </v-list-item-title>
                <v-list-item-subtitle>Author : {{ projectInfomation.authorEmail }}
                </v-list-item-subtitle>
                <v-list-item-subtitle>Created Date : {{ convertTimeStampToDate(projectInfomation.date) }}
                </v-list-item-subtitle>
                <v-list-item-subtitle>LastModified Date : {{convertTimeStampToDate(projectInfomation.lastModifiedDate) }}
                </v-list-item-subtitle>
                <v-list-item-subtitle>Comment : {{projectInfomation.comment}}</v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
        <v-card-actions>

            <slot name="action" :project="projectInfomation">

                <v-btn text
                       :to="enterUrl()">
                    {{enterText}}
                </v-btn>

                <v-btn
                        v-if="projectInfo.location == 'mine'"
                        color="red"
                        text
                        @click="$EventBus.$emit('deleteProject',projectInfomation)"
                >
                    Delete
                </v-btn>
            </slot>

        </v-card-actions>
    </v-card>

</template>

<script>
    import firebase from 'firebase';

    export default {
        name: "ProjectCard",
        props: {
            projectInfo: Object,
        },
        data() {
            return {
                projectInfomation: null,
                yesterDayDate: null,
            }
        },
        created() {
            var me = this

            if (me.projectInfo.location == 'local') {

                var type
                var projectName
                var setProejctType
                var lastModifiedDate
                var lastImg

                if (me.projectInfo.projectId == 'init') {
                    type = 'es'
                    projectName = localStorage.getItem("localSaveProjectName") ? localStorage.getItem("localSaveProjectName") : 'local'
                    setProejctType = 'local'
                    lastModifiedDate = localStorage.getItem("localSaveTime") ? localStorage.getItem("localSaveTime") : Date.now()
                    lastImg = localStorage.getItem('localSaveImg') ? localStorage.getItem('localSaveImg') : 'https://github.com/sooheon45/eventstorming/blob/master/docs/media/evtstrm.jpg?raw=true'
                } else if (me.projectInfo.projectId == 'kuberInit') {
                    type = 'k8s'
                    projectName = localStorage.getItem("kuberLocalSaveProjectName") ? localStorage.getItem("kuberLocalSaveProjectName") : 'local'
                    setProejctType = 'kuberLocal'
                    lastModifiedDate = localStorage.getItem("kuberLocalSaveTime") ? localStorage.getItem("kuberLocalSaveTime") : Date.now()
                    lastImg = localStorage.getItem('kuberLocalSaveImg') ? localStorage.getItem('kuberLocalSaveImg') : 'https://github.com/sooheon45/eventstorming/blob/master/docs/media/evtstrm.jpg?raw=true'
                } else if (me.projectInfo.projectId == 'businessInit') {
                    type = 'bm'
                    projectName = localStorage.getItem("businessLocalModelProjectName") ? localStorage.getItem("businessLocalModelProjectName") : 'local'
                    setProejctType = 'businessLocal'
                    lastModifiedDate = localStorage.getItem("businessLocalModelTime") ? localStorage.getItem("businessLocalModelTime") : Date.now()
                    lastImg = localStorage.getItem('businessLocalModelImg') ? localStorage.getItem('businessLocalModelImg') : 'https://github.com/sooheon45/eventstorming/blob/master/docs/media/evtstrm.jpg?raw=true'
                }

                var convertEmail = localStorage.getItem("email") != null ? localStorage.getItem("email") : "anonymous@sample.org"
                convertEmail = convertEmail.split('@')[0]

                var obj = {
                    type: type,
                    author: localStorage.getItem("uid") != null ? localStorage.getItem("uid") : "anonymous",
                    authorEmail: convertEmail,
                    projectId: me.projectInfo.projectId,
                    latestVersion: '-init',
                    convertType: setProejctType,
                    date: Number(lastModifiedDate),
                    lastModifiedDate: Number(lastModifiedDate),
                    projectName: projectName,
                    img: lastImg,
                }

                me.projectInfo.lastModifiedDate = Number(lastModifiedDate)
                me.projectInfomation = obj

            } else {


                if (me.projectInfo.lastModifiedDate) {
                    console.log('exeist------------------------------')
                } else {
                    firebase.database()
                        .ref('definitions/' + me.projectInfo.projectId + '/information')
                        .once('value', function (snapshot) {

                            if (snapshot.exists()) {
                                var info = snapshot.val()
                                var convertType = me.projectInfo.location
                                var modelType = info.type ? info.type : 'es'

                                if (modelType == 'bm') {
                                    if (me.projectInfo.location == 'mine') {
                                        convertType = 'businessMine'
                                    } else if (me.projectInfo.location == 'share') {
                                        convertType = 'businessShare'
                                    } else if (me.projectInfo.location == 'every') {
                                        convertType = 'businessEvery'
                                    }
                                } else if (modelType == 'k8s') {
                                    if (me.projectInfo.location == 'mine') {
                                        convertType = 'kuberMine'
                                    } else if (me.projectInfo.location == 'share') {
                                        convertType = 'kuberShare'
                                    } else if (me.projectInfo.location == 'every') {
                                        convertType = 'kuberEvery'
                                    }
                                }

                                me.projectInfo.lastModifiedDate = info.lastModifiedDate

                                var obj = {
                                    type: modelType,
                                    author: info.author,
                                    authorEmail: info.authorEmail ? info.authorEmail.split('@')[0] : 'undefined',
                                    projectId: me.projectInfo.projectId,
                                    latestVersion: info.lastVersionName,
                                    convertType: convertType,
                                    date: info.date,
                                    lastModifiedDate: info.lastModifiedDate,
                                    projectName: info.projectName,
                                    img: info.img,
                                    shared: info.permissions ? true : false
                                }

                                me.$emit("cardProjectName", obj)
                                me.projectInfomation = obj

                            }
                        })

                }

            }


        },
        computed: {
            enterText() {
                var me = this
                if (me.projectInfomation.author == localStorage.getItem('uid')) {
                    return 'Edit'
                }
                return 'Join'
            },
            checkNewChip() {
                var me = this

                return false
            },
            displayChip() {
                var me = this
                if (me.projectInfomation.type == 'k8s') {
                    return {display: 'Kubernetes', color: 'blue'}
                } else if (me.projectInfomation.type == 'bm') {
                    return {display: 'BusinessModel', color: 'orange'}
                } else {
                    return {display: 'EventStorming', color: 'green'}
                }

            },
        },
        methods: {
            enterUrl() {
                var me = this
                var author = me.projectInfomation.author
                // var projectType = me.projectInfomation.convertType
                var projectId = me.projectInfo.projectId
                // var projectVersion = me.projectInfomation.latestVersion ? me.projectInfomation.latestVersion : null


                if (me.projectInfomation.type == 'es') {
                    return `storming/${author}/${projectId}`
                    // return "storming/" + author + "/" + projectType + "/" + projectId
                } else if (me.projectInfomation.type == 'k8s') {
                    return `kubernetes/${author}/${projectId}`
                    // return "kubernetes/" + author + "/" + projectType + "/" + projectId
                } else if (me.projectInfomation.type == 'bm') {
                    return `business-model-canvas/${author}/${projectId}`
                    // return "business-model-canvas/" + author + "/" + projectType + "/" + projectId
                }
            },
            convertTimeStampToDate(timeStamp) {
                var date = new Date(timeStamp);
                return date.getFullYear() + "년 " + (date.getMonth() + 1) + "월 " + date.getDate() + "일 " + date.getHours() + "시 " + date.getMinutes() + "분"
            },

        },
    }

</script>
